import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as _moment from 'moment';
import { environment } from "src/environments/environment";
import { CountResPonse, payload } from "../components/hospital-administrator/hospital-administrator.interface";
import { Subject } from "rxjs";
const moment = _moment;
@Injectable({providedIn: 'root'})
export class DashboardService {

  private notificationReportSubject = new Subject<boolean>();
  notificationReport$ = this.notificationReportSubject.asObservable();

  constructor(private http: HttpClient) {}

   emitNotificationReport(value: boolean): void {
    this.notificationReportSubject.next(value);
  }

  /* Hospital & Organization Admin API's */
  // getHospitalOrganizationDashboardData() {
  //   let currentDate = moment().format('YYYY-MM-DD');
  //   return this.http.get(`${environment.report_prefix_direct_url}/getHospDashReport?date=${currentDate}`);
  // }

  // getHospConsultantDashReport() {
  //   let currentDate = moment().format('YYYY-MM-DD');
  //   return this.http.get(`${environment.report_prefix_direct_url}/getHospConsultantDashReport?date=${currentDate}`);
  // }

  /* Psychologist & Psychology Admin API's */
  // getPsychologistPsychiatristDashboardData() {
  //   let currentDate = moment().format('YYYY-MM-DD');
  //   return this.http.get(`${environment.report_prefix_direct_url}/getUserDashboard?date=${currentDate}`);
  // }
  
  getDailyReports(reportDate,lead_source ? : any,page_size?: any,currentPage?: any) {
    return this.http.get(`${environment.report_prefix_direct_url}/getDashboardDailyReport?date=${reportDate}&lead_source=${lead_source}&?page_size=${page_size}&?current_page=${currentPage}`);
  }

  getRevenueReports(reportDate) {
    return this.http.get(`${environment.report_prefix_direct_url}/getRevenueReport?date=${reportDate}`);
  }
  viewRevenueReports(reportDate) {
    return this.http.get(`${environment.report_prefix_direct_url}/getRevenueReport?date=${reportDate}`);
  }

  getdailyExcelReport(reportDate){
    return this.http.get(`${environment.report_prefix_direct_url}/downloadDailyReport?date=${reportDate}`, { responseType: 'blob'});
  }

  // getUpcomingPatientList() {
  //   let currentDate = moment().format('YYYY-MM-DD');
  //   return this.http.get(`${environment.report_prefix_direct_url}/getUpcomingPatientList`);
  // }

  /* Receptionist Admin API's */
  // getReceptionistReport() {
  //   let currentDate = moment().format('YYYY-MM-DD');
  //   return this.http.get(`${environment.report_prefix_direct_url}/getReceptionistReport?date=${currentDate}`);
  // }

    /* Counselor Admin API's */
    // getConsularDashboardReport() {
    //   let currentDate = moment().format('YYYY-MM-DD');
    //   return this.http.get(`${environment.report_prefix_direct_url}/getConsularDashboardReport?date=${currentDate}`);
    // }

    getDashboardData(){
      return this.http.get(`${environment.report_prefix_direct_url}/getRppDashboard`);
    }


    // COunsellor DAshboard
    getCounsellorDashboardData(date?){
      return this.http.get(`${environment.report_prefix_direct_url}/getDashboardTotalReport?date=${date}`);
    }

    getDashboardDetails(payload){
      return this.http.post(`${environment.report_prefix_direct_url}/getDashboardTotalReportDetailsWithData`,payload);
    }

    // New Dasboard Hospiatal Admin API
    getDashboardHospitalReport(payload: payload){
      return this.http.post<CountResPonse>(`${environment.report_prefix_direct_url}/getDashboardHospitalReport`,payload);
    }

    getDashboardHospitalReportDiseaseWise(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientsWithDiseaseWise`,payload);
    }

    getDashboardHospitalReportWithData(payload){
      return this.http.post<CountResPonse>(`${environment.report_prefix_direct_url}/getDashboardHospitalReportWithData`,payload);
    }

    getHospitalAdminDashboardCountRefresh(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/hospitalAdminDashboardCount`,payload);
    }

    getHospitalAdminDashboardCount(){
      return this.http.get(`${environment.patient_registration_prefix_url}/reports/hospitalAdminDashboardCount`);
    }

    getHospitalAdminDashboardCountTwo(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/hospitalAdminDashboardCountTwo`,payload);
    }

   // Seven APIs For Card

   hospitalAdminDashboardCountReports(){
    return this.http.get(`${environment.patient_registration_prefix_url}/reports/hospitalAdminDashboardCountReports`);
    }

    hospitalAdminDashboardCountReportsupdateUser(){
      return this.http.get(`${environment.patient_registration_prefix_url}/reports/hospitalAdminDashboardCountReportsupdateUser`);
    }

    hospitalAdminDashboardCountTotalSessionAsPerPackage(){
      return this.http.get(`${environment.patient_registration_prefix_url}/reports/hospitalAdminDashboardCountTotalSessionAsPerPackage`);
    }

    hospitalAdminDashboardCountTotalSessionAsPerPackagePlanned(){
      return this.http.get(`${environment.patient_registration_prefix_url}/reports/hospitalAdminDashboardCountTotalSessionAsPerPackagePlanned`);
    }

    hospitalAdminDashboardCountTotalRevivalAndContinous(){
      return this.http.get(`${environment.patient_registration_prefix_url}/reports/hospitalAdminDashboardCountTotalRevivalAndContinous`);
    }

    hospitalAdminDashboardCountPatientAskingGrace(){
      return this.http.get(`${environment.patient_registration_prefix_url}/reports/hospitalAdminDashboardCountPatientAskingGrace`);
    }

    hospitalAdminDashboardCountPackageDuration(){
      return this.http.get(`${environment.patient_registration_prefix_url}/reports/hospitalAdminDashboardCountPackageDuration`);
    }

      
    getHospitalAdminDashboardData(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/hospitalAdminDashboardData`,payload);
    }

    
    getHospitalAdminDashboardCardsCount(){
      return this.http.get(`${environment.patient_registration_prefix_url}/reports/hospitalAdminDashboardCountCard`);
    }

    getAdminDashboardFeedbackV2Report(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/adminDashboardVersionTwoReport`,payload);
    }

    getV2DashboardReport(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/userUpcomingSessionDashboard`,payload);
    }

    getV2DashboardDrillDownReport(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/userDashboardVersionTwoReport`,payload);
    }

    getSecheduleData(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/userDashboard`,payload);
    }

    // Reporting Hospital Admin 
    getPlanWisePatient(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientsWithPlanWise`,payload);
    }

    getPlanWisePatientAnalysis(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPlanWisePatientAnalysis`,payload);
    }

       
    getPatientsWithPlanWiseWithData(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientsWithPlanWiseWithData`,payload);
    }

    // getPatientSessionReport(payload){
    //   return this.http.get(`${environment.patient_registration_prefix_url}/reports/getStatusofSessionsCount?date=${payload?.Date}`);
    // }

    getPatientSessionReport(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getStatusOfSessionsPatientWise`,payload);
    }

    
    // getStatusofSessionsDataWithData(payload){
    //   return this.http.post(`${environment.patient_registration_prefix_url}/reports/getStatusofSessionsData`,payload);
    // }

      
    getStatusofSessionsDataWithData(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getStatusofSessionsPatientWiseWithData`,payload);
    }
    
    getPlanWiseInactivePatient(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getInactivePatientsWithPlanWise`,payload);
    }

    getPlanWiseInactivePatientWithData(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getInactivePatientsWithPlanWiseWithData`,payload);
    }


    getInactivePatientListPlanWise(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getInactivePatientListPlanWise`,payload);
    }


    
    // getPatientGeographicalCoverage (payload){
    //   return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientStateWiseReport`,payload);
    // }

    getPatientGeographicalCoverage (payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientsGeographicalCoverageStatus`,payload);
    }
    getPatientGeographicalCoverageWithData(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientStateWiseReportWithData`,payload);
    }

    // getTeamAssessmentStatusReport(payload){
    //   return this.http.get(`${environment.patient_registration_prefix_url}/reports/getTeamAssessmentStatusReport?date=${payload}`,);
    // }

    getTeamAssessmentStatusReport(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getTeamAssignmentStatus`,payload);
    }
    
    getTeamAssessmentStatusReportData(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getTeamAssignmentStatusWithData`,payload);
    } 
    
    // getTeamAssessmentStatusReportData(payload){
    //   return this.http.post(`${environment.patient_registration_prefix_url}/reports/getTeamAssessmentStatusReportData`,payload);
    // }

    // getPatientsAskingGracePeriod(payload){
    //   return this.http.get(`${environment.patient_registration_prefix_url}/reports/getPatientsAskingGracePeriod?date=${payload?.Date}`);
    // }

    getPatientsAskingGracePeriod(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientsAskingGracePeriod`,payload);
    }

    // getPatientsAskingGracePeriodWithData(payload){
    //   return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientsAskingGracePeriodWithData`,payload);
    // }

    getPatientsAskingGracePeriodWithData(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientsAskingGracePeriodWithData`,payload);
    }

    // getPatientLongevityStatus(payload){
    //   return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientLongevityStatus`,payload);
    // }

    getPatientLongevityStatus(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientLongevityStatus`,payload);
    }

    getPatientLongevityStatusWithData(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getPatientLongevityStatusWithData`,payload);
    }

    // getStatusofDataFilledCount(payload){
    //   return this.http.get(`${environment.patient_registration_prefix_url}/reports/getStatusofDataFilledCount?date=${payload.Date}`,);
    // }

    getStatusofDataFilledCount(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getStatusOfDataFilled`,payload);
    }

    // getStatusofDataFilledData(payload){
    //   return this.http.post(`${environment.patient_registration_prefix_url}/reports/getStatusofDataFilledData`,payload);
    // }

    getStatusofDataFilledData(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/getStatusOfDataFilledData`,payload);
    }


    getallTablesMongodb(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/allTableNameMongodb`,payload);
    }

    getallTableNamePostgres(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/allTableNamePostgres`,payload);
    }

    getaMongoTableFieldDatatypes(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/tableFieldWithDatatypeFromMdb 
      `,payload);
    }

    getaPostgressTableFieldDatatypes(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/tableFieldWithDatatypeFromPdb 
      `,payload);
    }

    
    getallCountFromMdbTable(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/allCountFromMdbTable 
      `,payload);
    }

    getallCountFromPdbTable(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/allCountFromPdbTable 
      `,payload);
    }

    getexportAllMdbTable(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/exportAllMdbTable 
      `,payload);
    }

    getexportAllPdbTable(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/exportAllPdbTable 
      `,payload);
    }

    getallDataFromPdbTable(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/rpp/allDataFromPdbTable 
      `,payload);
    }


      getDiagnosisOfPatientList(payload){
      return this.http.get(`${environment.patient_registration_prefix_url}/reports/getDiagnosisOfPatientList?page_size=${payload?.page_size}&current_page=${payload?.current_page}`);
    }

    getPrimaryDiagnosis(){
      return this.http.get(`${environment.patient_registration_prefix_url}/master/getPatientFormDetails?field_name=primary_diagnosis&form_name=diagnosis`);
    }

    getAssociatedDiagnosis(){
      return this.http.get(`${environment.patient_registration_prefix_url}/master/getPatientFormDetails?field_name=associated_diagnosis&form_name=diagnosis`);
    }

    getInactiveReason(){
      return this.http.get(`${environment.patient_registration_prefix_url}/master/getPatientFormDetails?field_name=reason&form_name=inactive_reason`);
    }
    
    updateDiagnosisOfPatientList(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/updateDiagnosisOfPatientList 
      `,payload);
    }

    updateInactiveReasonPatientList(payload){
      return this.http.post(`${environment.patient_registration_prefix_url}/reports/updateInactiveReasonPatientList 
      `,payload);
    }

    getAllNotifications(notificationSlug: string) {
      return this.http.get(`${environment.patient_registration_prefix_url}/notification/getAllNotifications?slug=${notificationSlug}`)
    }

    updateNotification(notificationId: string, payload: any) {
      return this.http.put(`${environment.patient_registration_prefix_url}/notification/updateNotification/${notificationId}`, payload);
    }

}



